import React, { Fragment } from 'react';

import Dashboard from '../../../DashboardComponents/Dashboard';

const DashboardInDash = (props) => {
    let { graphprops } = props;
    return (
        <Fragment>
            <Dashboard
                match={{
                    params: {
                        name: graphprops && graphprops[graphprops.graph] && graphprops[graphprops.graph].dashboardName
                            ? graphprops[graphprops.graph].dashboardName
                            : '',
                    }
                }}
            />
        </Fragment>
    );
};

export default DashboardInDash;